import React, { useState } from 'react';
import API from '../../api';
import successAlert from '../../services/AlertS/sucess';
import errorAlert from '../../services/AlertS/error';

const GetTranscriptButton = ({ headers, t }) => {
    const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'rate_limited'
    const [remainingDownloads, setRemainingDownloads] = useState(null);

    const handleGetTranscript = async () => {
        setStatus('loading');

        try {
            const response = await API.post('student_transcript', {}, {
                headers,
                responseType: 'blob'
            });

            // Handle success
            const disposition = response.headers['content-disposition'];
            let filename = 'Statement_of_Result.pdf';
            if (disposition && disposition.includes('filename=')) {
                // Split on filename=" and take the part before the closing "
                const parts = disposition.split('filename="');
                if (parts.length > 1) {
                    filename = parts[1].split('"')[0];
                } else {
                    // fallback if quotes are missing
                    filename = disposition.split('filename=')[1];
                }
            }

            // Create blob link to download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Read headers
            const emailStatus = response.headers['x-email-status'];
            const remaining = response.headers['x-remaining-downloads'];

            if (remaining !== undefined) {
                setRemainingDownloads(remaining);
            }

            setStatus('success');

            let successMsg = t('get_transcript.success_email_sent', { remainingDownloads: remaining });
            if (emailStatus === 'failed') {
                successMsg = t('get_transcript.success_email_failed', { remainingDownloads: remaining });
            }

            successAlert(t('get_transcript.success_title'), successMsg);

        } catch (error) {
            if (error.response && error.response.data instanceof Blob) {
                const text = await error.response.data.text();
                try {
                    const errorData = JSON.parse(text);
                    const status = error.response.status;

                    if (status === 429) {
                        setStatus('rate_limited');
                        const msg = errorData.message || t('get_transcript.rate_limit_default');
                        errorAlert(t('get_transcript.rate_limit_title'), msg);
                    } else if (status === 401) {
                        localStorage.clear();
                        window.location.href = '/logout'; // Redirect to login page
                        errorAlert(t('get_transcript.session_expired_title'), errorData.error || t('get_transcript.session_expired_default'));
                    } else if (status === 404) {
                        setStatus('idle');
                        errorAlert(t('get_transcript.no_results_title'), errorData.error || t('get_transcript.no_results_default'));
                    } else {
                        // Other errors
                        setStatus('idle');
                        errorAlert(t('get_transcript.error_title'), errorData.error || t('get_transcript.error_default'));
                    }
                } catch (e) {
                    setStatus('idle');
                    errorAlert(t('get_transcript.error_title'), t('get_transcript.error_parse'));
                }
            } else {
                setStatus('idle');
                errorAlert(t('get_transcript.error_title'), t('get_transcript.error_unexpected'));
            }
        }
    };

    const isDisabled = status === 'loading' || status === 'rate_limited';

    return (
        <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left' }} className="mx-1">
            <button 
                onClick={handleGetTranscript} 
                className="btn btn-sm btn-primary"
                disabled={isDisabled}
            >
                {status === 'loading' ? (
                    <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '5px' }}></span>
                        {t('get_transcript.button_loading')}
                    </>
                ) : (
                    <>{t('get_transcript.button_idle')} <i className="fas fa-file-pdf" style={{ marginLeft: '5px' }}></i></>
                )}
            </button>
            
            {remainingDownloads !== null && status !== 'rate_limited' && (
                <small className="d-block text-muted mt-1" style={{ fontSize: '0.75rem' }}>
                    {t('get_transcript.downloads_remaining', { remainingDownloads })}
                </small>
            )}
        </div>
    );
};

export default GetTranscriptButton;
